"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _withStyles = _interopRequireDefault(require("@material-ui/core/styles/withStyles"));
var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));
var _Hidden = _interopRequireDefault(require("@material-ui/core/Hidden"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable no-unused-vars */

/* eslint-enable no-unused-vars */

class MTablePaginationInner extends React.Component {
  constructor() {
    super(...arguments);
    (0, _defineProperty2.default)(this, "handleFirstPageButtonClick", event => {
      this.props.onChangePage(event, 0);
    });
    (0, _defineProperty2.default)(this, "handleBackButtonClick", event => {
      this.props.onChangePage(event, this.props.page - 1);
    });
    (0, _defineProperty2.default)(this, "handleNextButtonClick", event => {
      this.props.onChangePage(event, this.props.page + 1);
    });
    (0, _defineProperty2.default)(this, "handleNumberButtonClick", number => event => {
      this.props.onChangePage(event, number);
    });
    (0, _defineProperty2.default)(this, "handleLastPageButtonClick", event => {
      this.props.onChangePage(event, Math.max(0, Math.ceil(this.props.count / this.props.rowsPerPage) - 1));
    });
  }
  renderPagesButton(start, end) {
    const buttons = [];
    for (let p = start; p <= end; p++) {
      const buttonVariant = p === this.props.page ? "contained" : "text";
      buttons.push( /*#__PURE__*/React.createElement(_Button.default, {
        size: "small",
        style: {
          boxShadow: "none",
          maxWidth: "30px",
          maxHeight: "30px",
          minWidth: "30px",
          minHeight: "30px"
        },
        disabled: p === this.props.page,
        variant: buttonVariant,
        onClick: this.handleNumberButtonClick(p),
        key: p
      }, p + 1));
    }
    return /*#__PURE__*/React.createElement("span", null, buttons);
  }
  render() {
    const {
      classes,
      count,
      page,
      rowsPerPage,
      theme,
      showFirstLastPageButtons
    } = this.props;
    const localization = (0, _objectSpread2.default)({}, MTablePaginationInner.defaultProps.localization, this.props.localization);
    const maxPages = Math.ceil(count / rowsPerPage) - 1;
    const pageStart = Math.max(page - 1, 0);
    const pageEnd = Math.min(maxPages, page + 1);
    return /*#__PURE__*/React.createElement("div", {
      className: classes.root
    }, showFirstLastPageButtons && /*#__PURE__*/React.createElement(_Tooltip.default, {
      title: localization.firstTooltip
    }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(_IconButton.default, {
      onClick: this.handleFirstPageButtonClick,
      disabled: page === 0,
      "aria-label": localization.firstAriaLabel
    }, theme.direction === "rtl" ? /*#__PURE__*/React.createElement(this.props.icons.LastPage, null) : /*#__PURE__*/React.createElement(this.props.icons.FirstPage, null)))), /*#__PURE__*/React.createElement(_Tooltip.default, {
      title: localization.previousTooltip
    }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(_IconButton.default, {
      onClick: this.handleBackButtonClick,
      disabled: page === 0,
      "aria-label": localization.previousAriaLabel
    }, /*#__PURE__*/React.createElement(this.props.icons.PreviousPage, null)))), /*#__PURE__*/React.createElement(_Hidden.default, {
      smDown: true
    }, this.renderPagesButton(pageStart, pageEnd)), /*#__PURE__*/React.createElement(_Tooltip.default, {
      title: localization.nextTooltip
    }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(_IconButton.default, {
      onClick: this.handleNextButtonClick,
      disabled: page >= maxPages,
      "aria-label": localization.nextAriaLabel
    }, /*#__PURE__*/React.createElement(this.props.icons.NextPage, null)))), showFirstLastPageButtons && /*#__PURE__*/React.createElement(_Tooltip.default, {
      title: localization.lastTooltip
    }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(_IconButton.default, {
      onClick: this.handleLastPageButtonClick,
      disabled: page >= Math.ceil(count / rowsPerPage) - 1,
      "aria-label": localization.lastAriaLabel
    }, theme.direction === "rtl" ? /*#__PURE__*/React.createElement(this.props.icons.FirstPage, null) : /*#__PURE__*/React.createElement(this.props.icons.LastPage, null)))));
  }
}
const actionsStyles = theme => ({
  root: {
    flexShrink: 0,
    color: theme.palette.text.secondary,
    marginLeft: theme.spacing(2.5)
  }
});
MTablePaginationInner.propTypes = {
  onChangePage: _propTypes.default.func,
  page: _propTypes.default.number,
  count: _propTypes.default.number,
  rowsPerPage: _propTypes.default.number,
  classes: _propTypes.default.object,
  localization: _propTypes.default.object,
  theme: _propTypes.default.any,
  showFirstLastPageButtons: _propTypes.default.bool
};
MTablePaginationInner.defaultProps = {
  showFirstLastPageButtons: true,
  localization: {
    firstTooltip: "First Page",
    previousTooltip: "Previous Page",
    nextTooltip: "Next Page",
    lastTooltip: "Last Page",
    labelDisplayedRows: "{from}-{to} of {count}",
    labelRowsPerPage: "Rows per page:"
  }
};
const MTableSteppedPagination = (0, _withStyles.default)(actionsStyles, {
  withTheme: true
})(MTablePaginationInner);
var _default = exports.default = MTableSteppedPagination;